module.exports = __webpack_public_path__ + "img/njd-home.92a66f7e.jpg";